import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { loadAction } from "./actions";

interface Advanced {
  fontSize: number;
  textOffsetFromIcon: number;
  iconSize: number;
  strokeWidth: number;
}

const advanced = createSlice({
  name: "advanced",
  initialState: {
    fontSize: 3.9,
    textOffsetFromIcon: 7,
    iconSize: 7,
    strokeWidth: 0.45,
  } as Advanced,
  reducers: {
    updated: (state, action: PayloadAction<Partial<Advanced>>) => ({
      ...state,
      ...action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(loadAction, (state, action) => ({
      ...state,
      ...action.payload.advanced,
    }));
  },
});

export default advanced;
